<template>
  <div>
    <header class="main_header">
      <div class="left_div">
        <div class="logo logo_heading">
          <a href="/"><img src="https://www.sitepal.com/api/examples/images/logo.png" alt="SitePal"></a>
        </div>
      </div>
    </header>

    <table id="tblContainer" cellspacing="0" align="center" border="0">

      <tr>
        <td id="tdContent">
          <p class="feature_entire_heading text-center f-bold h2" style="margin-bottom: 0px;" align="center"><b>AI Agent with Speech Input - VUE JS </b></p>
          <p class="feature_entire_heading text-center f-bold h3" style="margin-top: 10px;" align="center"><b>Using the AI Agent Wizard - NoCode Solution</b></p>
          <p class="feature_entire_heading text-center" id="normal-text" align="center">In this example we demonstrate
            an AI Agent that responds to speech input. <br>Read our <a class="selected_support"
              href="/docs/Implementing_Your_AI_Agent.pdf" target="_blank">technical note</a> to learn more.</p>
          <p class="feature_entire_heading text-center" id="warning-text">Note: as we've detected this browser does not
            yet support the Web Speech API we've automatically replaced speech input with text input.</p>

          <!-- <p class="feature_entire_heading text-center" id="warning-text">Note: as we've detected this browser does not
            yet support the Web Speech API we've automatically replaced speech input with text input.</p> -->

          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <td align="center" COLSPAN="2" class="feature_entire_heading text-center sayAi">
              <!-- ******************************* SITEPAL EMBED CODE START  ***********************  -->
              <div style="min-width: 900px; max-height: 460px;">
                <AiPlayer />

              </div>
            </td>

            <tr align="middle">
              <td align="center" COLSPAN="2" class="feature_entire_heading text-center">
                <p>Real-time Artificial Intelligence Engine provides automatic Text and
                  Audio responses to the questions provided. </p>
                <p>The Audio is generated automatically via a Text To Speech engine according to the selected voice and
                  language.</P><br>
              </td>
            </tr>
          </table>
        </td>
      </tr>

    </table>
    <footer>
      <div class="footer-menu oddcast text-center">
        <ul class="w-50 m-auto ">
          <li class="w-100 f-bold ">Please feel free to use the source code of this page as an example.</li>
          <li>To view the source code of this page, <a href="/api/examples/vue-ai-agent-speak/Sitepal-vue-ai-agent.zip"
              download="">download</a>
            souce code</li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>

// import SitePal from './Sitepal.vue'
import AiPlayer from './AiPlayer.vue'

export default {
  name: 'ThreeDCharacter',
  components: {
    AiPlayer
  },
  data() {
    return {
      speechRecognition: null,
      sppechStopCalled: 0,
      isMacSafari: 0,
      firstemptyAudioPlayed: 0,
      final_transcript: "",
      aiString: "",
      body: "",
      bodyText: "",
      htmlText: "",
      oldBodyText: "",
      textToSay: '',
      iframeContent: ''
    };
  },
  methods: {


    isFacebookApp() {
      // Implement your isFacebookApp function
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    },

  },
};
</script>

<style scoped>
@import 'https://sitepal.com/api/examples/css/apiExample.css';

header {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding: .5rem 1rem;

  p {
    margin-left: 1rem;
  }
}

.h3 {
  font-size: 1.5rem;
}

nav {
  margin-left: auto;

  ul {
    list-style: none;
  }

  ul li {
    display: inline-flex;
    margin-left: 1rem;
  }
}

.mt-4 button {
  border: 1px solid #CECECE;
  padding: 5px 15px;
  margin: 10px;
  border-radius: 5px;
  background: #CECECE;
  color: #000;
}

.p-3 {
  height: 40px !important;
  margin-bottom: 20px;
  background: #ececec;
  padding: 8px;
}

#warning-text {
  color: red;
  display: none;
}

form.form {
  float: left;
  width: 100%;
}
</style>